import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersTransactionLogsQuery } from '../store/services/customers';

const ProblemIncomingTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    customersProblemTransactions: {
      incoming: { logs },
    },
    customersDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const [getIncomingLogs, { isLoading }] =
    useLazyGetCustomersTransactionLogsQuery();

  const getIncomingLogsAction = useCallback(() => {
    getIncomingLogs(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!logs && transactionId) {
      getIncomingLogsAction();
    }
  }, [getIncomingLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_INCOMING_LIST,
      )}
    />
  );
};

export default ProblemIncomingTransactionLogContentHOC;
